import { motion } from 'framer-motion';
import { useI18n } from '../../context/I18nContext';
import AnimatedEyebrow from '../AnimatedEyebrow';
import ImageOnlySkeletonLoader from '../ImageOnlySkeletonLoader';

export default function HomeVideoBannerSection() {
  const { language, t } = useI18n();

  const containerVariants = {
    hidden: { opacity: 0, y: 28 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.08,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 22 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.75, ease: [0.22, 1, 0.36, 1] },
    },
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative h-[56vh] min-h-[420px] w-full md:h-[62vh] md:min-h-[520px]">
        <ImageOnlySkeletonLoader
          mode="video"
          videoSources={[{ src: '/videos/1.mp4', type: 'video/mp4' }]}
          containerClassName="absolute inset-0"
          videoClassName="absolute inset-0 h-full w-full object-cover"
        />

        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-black/20" />

        <div className="relative z-10 flex h-full items-center">
          <div className="container mx-auto px-6 lg:px-12">
            <motion.div
              key={language}
              className="max-w-xl"
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: '-120px' }}
            >
              <motion.h2 variants={itemVariants} className="text-4xl font-light uppercase leading-tight text-white sm:text-5xl">
                <span className="block">{t('home.videoBanner.titleLine1')}</span>
                <span className="block font-black text-[var(--dash-other)]">{t('home.videoBanner.titleLine2')}</span>
              </motion.h2>
              <motion.p variants={itemVariants} className="mt-5 text-sm font-light leading-relaxed text-white/85 sm:text-base lg:text-lg">
                {t('home.videoBanner.description')}
              </motion.p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
